import React from "react";
import { MDBContainer } from "mdbreact";

import Banner from "../../../template/Banner";

import "./styles.css";

export default () => {
  return (
    <div className="donation">
      <Banner
        title="Doação"
        subtitle="Contribua com uma doação de qualquer valor para que possamos ajudar cada vez mais pessoas."
      />
      <MDBContainer className="mt-5">
        <h1>Dados bancários</h1>
        <h4>
          Banco Bradesco <br />
          Agência 261 <br />
          Conta Corrente 76.001-3
        </h4>
      </MDBContainer>
    </div>
  );
};
